export default __webpack_public_path__ + "static/media/blank_classes.9d6757f4.svg";